export default import.meta.ROLLDOWN_FILE_URL_9i17u1nN6xOO2zERFy_0aw